import { UiSettings } from "list-types-public";
import { PatientsFilters } from "../manageb/previous-cases/previous-cases-filters/previous-cases-filters.interface";

export class User {
    firstName: String;
    lastName: String;
    _id: String;
    username: String;
    password: String;
    role: String;
    time: Date;
    phoneNumber: String;
    email: String;
    isAccredited: Boolean;
    roleNumber: number;
    protfolios: String[];
    defaultProtfolio: String;
    personalInfo: PersonalInfo = new PersonalInfo();
    accreditedFile: {
        fileUrl: String,
        status: String,
        files?: {fileUrl: String, fileName: String}[],
    };
    platformSettings: {
        dontShowFirstPopups: Boolean,
    };

}

export class PersonalInfo {
    email: String;
    firstName: String;
    lastName: String;
    phoneNumber: String;
    country: String;
    city: String;
    address: String;
    facebook: String;
    linkedin: String;
}

export type CustomPermissionKey = 'userCredentials' | 'ehrCredentials';
export type CustomPermissions = Partial<Record<CustomPermissionKey, boolean>>;

/** The Report Builder runs under ComplAI and under MDS; each saved report belongs to one. */
export type ReportArea = 'complai' | 'mds';

export class UserToken {
    user: User;
    token: string;
    sessionId: String;
    changePassword: Boolean;
    expirationTime: Date;
    role: number;
    fullName: string;
    settings: {
        facilities: number[];
        allFacilities: Boolean;
        patientsFilters: PatientsFilters;
        respondToEhrEnabled?: boolean;
        defaultFields?: UserDefaultFields;
        regionId?: number;
        timezone?: string;
        uiSettings?: UiSettings & { defaultScreen?: string; legacyNavigation?: boolean };
    }
    regionId: string;
    customPermissions?: CustomPermissions;
}
export interface UserDefaultFields {
    defaultPushFacility?: {};
}

export class PolycyHolder {
    _id: String;
    email: String;
    firstName: String;
    lastName: String;
    ID: String;
    time: String;

}
